export default [
    {
        path: "/publish/daily-part-one",
        component: () => import("./List.vue"),
        name: "daily-daily-part-one",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/publish/daily-part-one/:id/edit",
        component: () => import("./Edit.vue"),
        name: "publish-daily-part-one-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/publish/daily-part-one/create",
        component: () => import("./Create.vue"),
        name: "publish-daily-part-one-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/daily-part-one",
        component: () => import("./Events.vue"),
        name: "daily-part-one",
        meta: {
            requiresAuth: true,
        },
    },
];
